export default {"src":"/_next/static/media/linked_in.b7de21e5.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};